import { createReducer, on } from '@ngrx/store';
import { storeChatData, clearChatData, setLoading, clearLoading } from './chat.actions';
import { ChatState } from './chat.model'; 
import { useLocalStorage } from '../../utilities/browser/localStorage.utilities';

const { getItem, setItem, removeItem } = useLocalStorage();

const getDefaultState = (): ChatState => ({
  chat: {
    transactionId: ''
  },
  isLoading: false,
});

const loadInitialState = (): ChatState => {
  const storedChat = getItem('chat');
  const storedLoading = getItem('isLoading');
  return storedChat && storedLoading ? {
    chat: JSON.parse(storedChat),
    isLoading: JSON.parse(storedLoading)
  } : getDefaultState();
};

export const initialState: ChatState = loadInitialState();

export const chatReducer = createReducer(
  initialState,
  on(storeChatData, (state, { chat }) => {
    const newState = {
      ...state,
      chat
    };
    setItem('chat', JSON.stringify(newState.chat));
    return newState;
  }),
  on(clearChatData, () => {
    removeItem('chat');
    return getDefaultState();
  }),
  on(setLoading, (state, { isLoading }) => {
    setItem('isLoading', JSON.stringify(isLoading));
    return {
      ...state,
      isLoading
    };
  }),
  on(clearLoading, (state) => {
    removeItem('isLoading');
    return {
      ...state,
      isLoading: false
    };
  })
);